import { CaseResolution, FamilyChangeRequestDecision } from "~/graphql/supergraphEnums";

/**
 * GP EUM cases store their negative terminal as `rejected` (FA cases use
 * `invalid` — the DB CHECK constraint disallows `invalid` for GP rows);
 * product copy renders both as "Invalid". Single source of truth for every
 * surface that submits, renders, narrates, or filters this terminal.
 */
export const GP_NEGATIVE_TERMINAL_DECISION = FamilyChangeRequestDecision.Rejected;

export const RESOLUTION_FILTER_FIELD = "resolution";

export const INVALID_RESOLUTION_VALUES: string[] = [
  CaseResolution.Invalid,
  CaseResolution.Rejected,
];
